<template>
  <div :id="`${source}_entity_scoring_toggle`" class="px-2" data-no-row-click>
    <a-switch size="small" :checked="isEnabled" @change="handleSwitchChange" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import DashboardService from "@/src/api/DashboardService.js";
import { standardObjects } from "@/src/constants/objectConstants.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const emits = defineEmits(["status-update"]);
const store = useStore();

const isEnabled = ref(props.row?.entity_status === true);

const handleSwitchChange = async (checked) => {
  try {
    isEnabled.value = checked;

    const payload = {
      entity_status: checked,
    };

    const response = await DashboardService.updateEntityScoringStatus(
      props.row?.entity_type,
      payload
    );

    if (response?.success) {
      message.success(
        `${props.row?.entity_label} scoring ${checked ? "enabled" : "disabled"}`
      );

      // Get the slug from standardObjects mapping
      const standardObject = standardObjects.find(
        (obj) => obj.viewSlug === props.row.entity_type
      );
      const entitySlug = standardObject?.slug || props.row.entity_type;

      // Update views store with new entity scoring status and refresh schema
      if (entitySlug) {
        await store.dispatch("views/setEntityScoringStatus", {
          entityType: entitySlug,
          enabled: checked,
        });

        await new Promise((r) => setTimeout(r, 2000));
        await store.dispatch("schema/refreshSchema", {
          slug: entitySlug,
        });
      }

      emits("status-update");
    } else {
      message.error("Failed to update status");
      isEnabled.value = !checked;
    }
  } catch (error) {
    isEnabled.value = !checked;
    console.error("An error occurred while updating status: ", error);
    message.error("An error occurred while updating status");
  }
};

watch(
  () => props.row?.entity_status,
  (newVal) => (isEnabled.value = Boolean(newVal)),
  { immediate: true }
);
</script>
